window.app_models.lease_detail = {
    id:null,
    lease_rate:null,
    lease_rate_type:null,
    pet_rent:null,
    parking_rent:null,
    other_rent:null,
    landlord_deposit: null,
    furniture_deposit: null,
    returned_to: null,
    cleaning_fee: null,
    application_fee: null,
    furniture_cleaning_fee: null,
    furniture_delivery_fee: null,
    pet_fee: null,
    misc_fee: null,
    misc_desc: null,
    beginning_date:null,
    end_date:null,
    mtm_beginning_date:null,
    mtm_end_date:null,
    insurance_approved_extension_date:null,
    note:null,
    property_id:null,
    property_lease_term_id:null,
    property_lease_term:{
        id: null,
        name: null
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/lease_detail.js